/*
 * @Author: Lina
 * @Date: 2020-07-27 13:20:31
 * @LastEditors: Lina
 * @LastEditTime: 2020-07-27 22:26:29
 */ 
import React, { PureComponent } from 'react';
import './index.scss'

/**
 * @mask 弹窗是否开启
 * @onClose 关闭弹窗事件
 * @list 城市数据
 * @cityClick 城市点击事件 返回城市信息
 * @initInfo 城市初始化信息
 */


class CityListSelect extends PureComponent{
  constructor(props) {
    super(props);
    const {initInfo} = this.props;
    this.state = {
      cityCode: initInfo.cityCode || "110100"
    }
  }

  onClick = (data)=>{
    const {onClose, onCityClick} = this.props;
    onClose && onClose();
    onCityClick && onCityClick(data)
  }
  render(){
    const {cityCode} = this.state;
    const { list, onClose, initInfo} = this.props;
    return (
      <div className="CityListSelect">
        <div className="cityList">
          <div className="titleModule">
            <p className="closeButton" onClick={() => onClose && onClose()}></p>
            <p className="title">选择热门城市</p>
          </div>
          <div className="cityContent">
            <p className="cityTip">热门城市</p>
            <div className="cityModule">
              {
                list.map(item => (
                  <div className={`citySelect ${cityCode === item.cityCode && 'userSelect'}`} key={item.cityCode} onClick={() => this.onClick(item)}>{item.cityName}</div>
                ))
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CityListSelect
